/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeContainer, useListe } from '@mairistem/liste';

import { TypeListePacs } from '@/enums';
import { OPTIONS_STATUT_LISTE_PACS } from '@/constants';
import type { TypePacs, Pacs } from '@/types/Pacs';
import PacsListe from './PacsListe';

interface PacsListeContainerProps {
  all?: boolean;
  datePacs?: string | null;
  typePacs?: TypePacs | null;
  /**
   * Filtre de liste, cf. enum TypeListePacs. Accepte également plusieurs
   * valeurs séparées par une virgule (ex: `${TypeListePacs.PacsProjet},${TypeListePacs.PacsEnCours}`).
   */
  typeListe?: TypeListePacs | string;
  dashboard?: boolean;
  modal?: boolean;
  stats?: boolean;
  assistant?: boolean;
  projet?: boolean;
  'data-testid'?: string;
  onSelect?: (item: Partial<Pacs>) => void;
}

const PacsListeContainer = ({
  all,
  datePacs, // mode liste conventions
  typePacs, // mode liste conventions
  typeListe, // mode liste PACS
  dashboard = false,
  modal = false,
  stats,
  assistant,
  projet,
  'data-testid': dataTestId = 'pacs-liste',
  onSelect,
}: PacsListeContainerProps = {}) => {
  const defaultFilters = {
    ...(all && { all }),
    ...(modal && { allConventions: true }),
    ...(datePacs && { datePacs }),
    ...(typePacs && { typePacs }),
    ...(typeListe && { typeListe }),
  };

  // Statuts proposés dans le filtre : ceux couverts par la liste
  const typesListe = String(typeListe ?? '')
    .split(',')
    .map((type) => parseInt(type, 10))
    .filter((type) => !Number.isNaN(type));
  const toutPacs = typesListe.includes(TypeListePacs.ToutPacs);
  const optionsStatut = OPTIONS_STATUT_LISTE_PACS.filter(
    ({ value }) => toutPacs || typesListe.includes(value),
  );

  const [service] = useListe(
    stats
      ? '/api/administres/etat-civil/conventions/liste'
      : '/api/administres/etat-civil/pacs/liste',
    defaultFilters,
  );

  return (
    <ListeContainer type="pacs" contains="liste" service={service} perPage={20}>
      <PacsListe
        dashboard={dashboard}
        modal={modal}
        stats={stats}
        assistant={assistant}
        projet={projet}
        toutPacs={toutPacs}
        optionsStatut={
          optionsStatut.length > 1 &&
          !dashboard &&
          !modal &&
          !stats &&
          !assistant
            ? optionsStatut
            : undefined
        }
        data-testid={dataTestId}
        onSelect={onSelect}
      />
    </ListeContainer>
  );
};

export default PacsListeContainer;
